import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AbstractApiGuardService } from '../abstract.api-guard.service';
import { ApplicantModel } from '../../../shared/models/states/applicant.model';

@Injectable({
    providedIn: 'root',
})
export class ApplicantService extends AbstractApiGuardService {
    private readonly apiUrl = `${environment.apiVersionString}/applicants`;

    // Create an application
    // createApplicant(application: ApplicantModel, loanId: string): Observable<ApplicantModel> {
    //     return this.post<ApplicantModel>(`${this.apiUrl}/${loanId}`, application).pipe(map(setApplicantType));
    // }

    // Read all applications
    // getLoanApplicants(): Observable<ApplicantModel[]> {
    //   return this.get(this.apiUrl);
    // }

    getApplicantsByLoanApplicationId(loan_application_uuid: string): Observable<ApplicantModel[]> {
        return this.get<ApplicantModel[]>(`${this.apiUrl}/loan_application_id/${loan_application_uuid}`).pipe(map(setApplicantTypes));
    }

    createApplicant(loanId: string): Observable<ApplicantModel> {
        return this.get<ApplicantModel>(`${this.apiUrl}/user/${loanId}`).pipe(map(setApplicantType));
    }

    // Read a single application by ID
    getApplicantById(id: string): Observable<ApplicantModel> {
        return this.get<ApplicantModel>(`${this.apiUrl}/applicant_id/${id}`).pipe(map(setApplicantType));
    }

    // Update an application
    updateApplicant(id: string, application: ApplicantModel): Observable<ApplicantModel> {
        return this.put<ApplicantModel>(`${this.apiUrl}/${id}`, application).pipe(map(setApplicantType));
    }

    // Delete an application
    deleteApplicant(id: string): Observable<void> {
        return this.delete(`${this.apiUrl}/${id}`);
    }
}

function setApplicantType(a: ApplicantModel): ApplicantModel {
    return {
        ...a,
        applicant_type: "Applicant"
    }
    // return Object.assign(a, {
    //     applicant_type: "Applicant"
    // });
}

function setApplicantTypes(a: ApplicantModel[]): ApplicantModel[] {
    return a.map(setApplicantType);
}
